import React, { useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

import { UserProfileCss } from "./UserProfileCss";

interface AccountDetailsProps {
  handleFieldChange: any;
  formData: any;
  user: any;
  submitForm: any;
}

const AccountDetails = ({
  handleFieldChange,
  formData,
  user,
  submitForm
}: AccountDetailsProps) => {

  useEffect(() => {
    document.title = `My Account | Staidium`;
  }, []);

  return (
    <div className="account-form-container-wrapper our-product-left_m">
      <div className="login">
        <div className="account-form-container">
          <div className="account-login-form">
            <Form>
              <div
                className="my-account-form-wrap border-bottom-2 white pb--30"
                style={{
                  borderBottom: "1px solid #444",
                  paddingBottom: "30px"
                }}
              >
                <h3>General Information</h3>
                <p>
                  By letting us know your name, we can make our support
                  experience much more personal.
                </p>
                <Row className="account-input-box">
                  <Col md={6} className="single-input-box">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="first-name"
                        onChange={(e) =>
                          handleFieldChange("firstName", e.target.value)
                        }
                        value={formData.firstName}
                        style={UserProfileCss.input}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="single-input-box">
                    <Form.Group controlId="formLastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="last-name"
                        value={formData.lastName}
                        style={UserProfileCss.input}
                        onChange={(e) =>
                          handleFieldChange("lastName", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="single-input-box mt--15">
                    <Form.Group controlId="formDisplayName">
                      <Form.Label>Display Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          user && `${formData.firstName}  ${formData.lastName}`
                        }
                        style={UserProfileCss.input}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="single-input-box mt--15">
                    <Form.Group controlId="formEmailAddress">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email-name"
                        value={formData.email}
                        defaultValue="info@example.com"
                        style={UserProfileCss.input}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              <div className="button-box mt--30" style={{ marginTop: "30px" }}>
                <Button
                  variant="danger"
                  onClick={submitForm}
                  style={{
                    borderRadius: 0,
                    fontWeight: "bold"
                  }}
                >
                  Save Changes
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
